import { INTEGRATIONS_PANEL_FACTS } from '../RentalPortalIntegrationsPanel.constants'

import { IntegrationsPanelFact } from './IntegrationsPanelFact'

import * as styles from './IntegrationsPanelFacts.module.css'

function IntegrationsPanelFacts({ connection }) {
  return (
    <div className={styles.IntegrationsPanelFacts}>
      {INTEGRATIONS_PANEL_FACTS.map(fact => (
        <IntegrationsPanelFact
          connection={connection}
          fact={fact}
          key={fact.name}
        />
      ))}
    </div>
  )
}

export default IntegrationsPanelFacts
